import { createSignal, onMount } from "solid-js";
import { useApplication } from "@/context/app";
import { useConfirmer } from "@/context/confirmer";
import {
  Card,
  CardContent,
} from "@/components/shadcn/card";
import { ListControl } from "../../components/ui/list/ListControl";
import { TableView } from "../../components/ui/list/TableView";
import { getPaymentColumns } from "./columns";
import { CreateModalTrigger } from "../../components/ui/Button";
import { PaymentModal } from "./modal";

export default function PaymentList({ type = "Customer" }) {

  const [listControl, setListControl] = createSignal(null);

  const [showCreateModal, openCreateModal] = createSignal(false);
  const [key, setKey] = createSignal(null);
  const [appointmentId, setAppointmentId] = createSignal(null);
  const { setBreadcrumb } = useApplication();
  const { showConfirmer } = useConfirmer();

  const onModalCreate = () => {
    setKey(null);
    setAppointmentId(null);
    openCreateModal(true);
  }

  const onClear = (appointmentKey) => {
    showConfirmer(
      '/payment/clear',
      [appointmentKey],
      'Clear Payment',
      'Are you sure you want to mark this payment as fully paid?',
      () => { listControl()?.refresh(); },
      'Confirm',
      false,
      'clear'
    );
  };

  const onRecordPayment = (appointmentKey) => {
    setKey(null);
    setAppointmentId(appointmentKey);
    openCreateModal(true);
  };

  onMount(async () => {
    setBreadcrumb([
      {
        name: 'Home',
        link: '/home'
      },
      {
        name: "Appointment Payments",
        current: true
      }
    ]);
  });

  return (
    <>
      <div class="flex">
        <CreateModalTrigger onClick={onModalCreate}>New Payment</CreateModalTrigger>
        <PaymentModal
          key={key()}
          appointmentId={appointmentId()}
          type={type}
          open={showCreateModal()}
          onRefresh={() => { listControl()?.refresh() }}
          onClose={() => openCreateModal(false)}
        />
      </div>
      <Card class="w-full">
        <CardContent>
          <ListControl
            ref={setListControl}
            search={''}
            mode="table"
            actions={[]}
            filters={[
              {
                type: 'date',
                label: 'Date',
                name: 'date',
                default: null
              }
            ]}
            sort={{
              column: 'date',
              direction: 'desc'
            }}
            pagination={{
              current: 1,
              changePerPage: true,
              perPage: 10,
              options: [10, 20, 50, 100]
            }}
            datasource={{
              type: 'remote',
              config: {
                url: '/payment/fetch',
                method: 'GET',
                params: {}
              }
            }}
          >{(innerProps) => <TableView actionKey='key' {...innerProps} columns={getPaymentColumns({ onClear, onRecordPayment })} />}
          </ListControl>
        </CardContent>
      </Card>
    </>
  );
}
